import React from "react";
import ProfileThumbnail from "../ProfileThumbnail";

export function formatGoingPreviewLabel(preview, total) {
  if (!preview?.length || total <= 0) return null;
  const firstNames = preview
    .map((guest) => (guest.hide_name ? "Someone" : (guest.name?.split(" ")[0] || guest.name || "Someone")))
    .slice(0, 2);
  if (firstNames.length === 1) {
    const extra = total - 1;
    return extra > 0 ? `${firstNames[0]} +${extra}` : firstNames[0];
  }
  if (firstNames.length >= 2) {
    const plus = total - 2;
    return plus > 0 ? `${firstNames[0]}, ${firstNames[1]} +${plus}` : `${firstNames[0]} and ${firstNames[1]}`;
  }
  return null;
}

/** Compact avatar stack + first-name preview for feed cards. */
export default function FeedGoingPreview({ preview, total, dimmed = false, className = "" }) {
  const label = formatGoingPreviewLabel(preview, total);
  if (!label) return null;

  const textClass = dimmed ? "text-cream/85" : "text-ink/75";

  return (
    <div
      className={`flex items-center gap-2 min-w-0 relative z-[1] rounded-btn ${
        dimmed ? "" : "going-proof-bar"
      } ${className || "mt-2"}`}
      data-testid="feed-going-preview"
    >
      <span className="sr-only">{total} going, including {label}</span>
      <div className="flex -space-x-2 shrink-0" aria-hidden>
        {preview.slice(0, 3).map((guest, index) => (
          <span key={guest.dancer_id || `${guest.name}-${index}`} className="avatar-ring-salsa relative inline-flex rounded-full">
            <ProfileThumbnail
              name={guest.name}
              role={guest.role}
              thumbnailUrl={guest.thumbnail_url}
              hidden={guest.hide_name}
              size="sm"
              className="ring-2 ring-white shadow-none border border-black/[0.08] font-ui font-semibold"
            />
          </span>
        ))}
      </div>
      <p className={`font-ui text-[13px] font-medium truncate ${textClass}`}>
        {label}
      </p>
    </div>
  );
}
